import { SvgIcon } from '@material-ui/core'

export default function CallIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 26 24" fill="none" {...props}>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.6978 15.8464C7.82589 16.2438 8.55279 15.1111 9.07818 13.5915C9.44234 12.54 9.75488 11.6307 12.9319 11.6314C16.1089 11.6321 16.4215 12.54 16.7842 13.5901C17.3089 15.1118 18.0386 16.246 22.1681 15.8457C23.1496 15.7482 23.9076 15.3296 24.4012 14.5984C25.4548 13.0597 24.928 10.7015 24.9266 10.703C24.6975 9.32551 23.0683 6.12373 12.9319 6.12302C6.2646 6.12232 3.27919 7.50824 1.95266 8.83478C1.26182 9.52562 1.0214 10.1988 0.947155 10.6535C0.940791 10.6768 0.387127 13.0336 1.46334 14.6005C1.96327 15.3296 2.71421 15.7482 3.6978 15.8464Z"
                    fill="currentColor"
                />
            </g>
        </SvgIcon>
    )
}
